var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { svgIcon } from '../svg-icon';
/**
 * @tdr
 */
export var Filter = svgIcon(function (props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "11" }, props, { viewBox: "0 0 16 11", fill: "none" }),
        React.createElement("line", { x1: "1.25", y1: "1.25", x2: "14.75", y2: "1.25", stroke: "#53565A", strokeWidth: "1.5", strokeLinecap: "round" }),
        React.createElement("line", { x1: "3.25", y1: "4.25", x2: "12.75", y2: "4.25", stroke: "#53565A", strokeWidth: "1.5", strokeLinecap: "round" }),
        React.createElement("line", { x1: "5.25", y1: "7.25", x2: "10.75", y2: "7.25", stroke: "#53565A", strokeWidth: "1.5", strokeLinecap: "round" }),
        React.createElement("line", { x1: "7.25", y1: "10.25", x2: "8.75", y2: "10.25", stroke: "#53565A", strokeWidth: "1.5", strokeLinecap: "round" })));
});
//# sourceMappingURL=Filter.js.map